import { AnimatePresence } from "framer-motion";
import React, {useContext, useState} from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import AuthContext from "./context/AuthContext";
import { Dashboard } from "./pages/Dashboard";
import Home from "./pages/Home";
import SelfAssessment from "./pages/SelfAssessment";
import LandingPage from "./pages/LandingPage";
import "./App.scss";
import { Result } from "./pages/Result";
export enum Routes {
  HOME = "/",
  NEW_ASSESSMENT = "/selfassessment",
  ASSESSMENT = "/assessment/:id",
  REPORTS = "/echoreports",
}

const App = () => {
  const { token } = useContext(AuthContext);
  const [ showHeader, setShowHeader ] = useState<boolean>(true);
  return (
    <AnimatePresence>
      <Router>
        { showHeader ? <Header /> : "" }
        <Switch>
          <Route exact path={Routes.HOME}>
            {token?.length ? <LandingPage /> : <Home />}
          </Route>
          <Route path="/selfassessment">
            <SelfAssessment />
          </Route>
          <Route path="/echoreports">
            <Dashboard />
          </Route>
          <Route path="/result/:id">
            <Result headerControl={setShowHeader} />
          </Route>
        </Switch>
      </Router>
    </AnimatePresence>
  );
};

export default App;
